<template>
    <b-container class="d-flex flex-column mw-100 mh-100 h-100 m-0 p-0 overflow-auto flex-wrap">
        <b-row class="m-0 p-0 pr-2 pl-1 h-100 mh-100 w-100 mw-100">
            <b-col class="m-0 p-0 d-flex flex-column">
                <!-- Date de sélection -->
                <b-row class="bg-gray-light m-0 p-0" align-v="center" hidden>
                    <b-col class="border m-0 p-1 pl-2 font-weight-bold">
                        {{ getSelectedDate(factorCalendarTypeEnum.Month, startPeriod, endPeriod) }}
                    </b-col>
                </b-row>
                <!-- Numéro des heures -->
                <b-row class="m-0 p-0 flex-grow-1">
                    <b-col class="m-0 p-0" style="width: 5%; min-width: 5%"/>
                    <b-col class="m-0 p-0" style="width: 95%; min-width: 95%; left:-8px;">
                        <b-row class="m-0 p-0 w-100 wm-100 h-100 mh-100 border-transparent" align-v="end">
                            <b-col class="m-0 p-0 border-0" v-for="(n,index) in 24" :key="index">
                                <b-row class="m-0 p-0 h-100 mh-100" align-v="end">
                                    <b-col class="m-0 p-0 font-weight-bold">
                                        {{ (n-1) > 9 ? (n-1): '&nbsp;' + (n-1) }}h
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <!-- Affichage des jours avec les traits des heures-->
                <b-row class="m-0 p-0 flex-grow-1 border bi-border-white"
                       v-for="(monthInfo,index) in monthInfos" :key="index" :style="'height:1em'">
                    <b-col class="m-0 p-0" style="width: 5%; min-width: 5%">
                        <b-row class="m-0 p-0 h-100 mh-100" align-v="center" style="font-size:10px;"
                               @click="onClick(undefined, monthInfo.dayId, undefined)" role="button"
                               :class="monthInfo.weekend ? 'bg-gray-light' : ''">
                            <b-col class="m-0 p-0 pl-1 text-right">
                                {{ monthInfo.dayName }}
                            </b-col>
                            <b-col class="m-0 p-0 pl-1">
                                <b>{{ monthInfo.dayId }}</b>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col class="m-0 p-0 d-flex" style="width: 95%; min-width: 95%">
                        <!-- Affichage des traits des heures/minutes -->
                        <svg :viewBox="'0 0 ' + (1440 + (monthInfo.dayClocksChange == 1? 60: 0)) + ' 100'"
                             width="100%" height="1rem" preserveAspectRatio="none"
                             xmlns="http://www.w3.org/2000/svg" class="flex-grow-1"
                             @click="onClick($event, monthInfo.dayId, undefined)">
                            <defs>
                                <pattern id="pattern-stripe"
                                         width="4" height="4"
                                         patternUnits="userSpaceOnUse"
                                         patternTransform="rotate(45)">
                                    <rect width="2" height="4" transform="translate(0,0)" fill="white"></rect>
                                </pattern>
                                <mask id="mask-stripe">
                                    <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-stripe)"/>
                                </mask>
                            </defs>

                            <template v-for="(data, index) in Data[monthInfo.dayId - 1]?.values">
                                <template v-if="data != undefined">
                                    <template v-if="!Number.isNaN(data.value) && Number(data.value) >= 0">
                                        <template v-if="data.lenghtMinutesValue != 0">
                                            <rect :width="data.lenghtMinutesValue" :height="data.valuePourcent"
                                                  :x="data.startMinutesValue" :y="100 - data.valuePourcent"
                                                  :style="'fill: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                  @mouseover="onMouveOverValues(monthInfo.dayId, data.startMinutesValue)"
                                                  @click="onClick($event, monthInfo.dayId, data.startData.id)"
                                                  :id="'day' + monthInfo.dayId + '_data' + data.startData.id"/>
                                            <polygon points="5,50 15,15 15,85" fill="white" v-if="!data.isFadeIn"
                                                     :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                     stroke-width="1"/>  <!-- flèche gauche -->
                                            <!-- une heure de plus (Changement d'heure) -->
                                            <template v-if="monthInfo.dayClocksChange == 1">
                                                <polygon points="1495,50 1485,15 1485,85" fill="white"
                                                         v-if="!data.isFadeOut"
                                                         :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                         stroke-width="1"/>  <!-- flèche droite -->
                                            </template>
                                            <template v-else>
                                                <polygon points="1435,50 1425,15 1425,85" fill="white"
                                                         v-if="!data.isFadeOut"
                                                         :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                         stroke-width="1"/>  <!-- flèche droite -->
                                            </template>
                                        </template>

                                        <line :x1="data.startMinutesValue" y1="100" class="pointor"
                                              :x2="data.startMinutesValue" :y2="100 - data.valuePourcent"
                                              :style="'stroke: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                              :stroke-width="data.lenghtMinutesValue == 0 ? 1 : data.lenghtMinutesValue"
                                              @mouseover="onMouveOverValues(monthInfo.dayId, data.startMinutesValue)"
                                              v-if="data.lenghtMinutesValue == 0"/>
                                    </template>
                                    <template v-else>
                                        <template v-if="data.lenghtMinutesValue != 0">
                                            <rect :width="data.lenghtMinutesValue" :height="data.valuePourcent"
                                                  :x="data.startMinutesValue" y="0"
                                                  :style="'fill: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                  @mouseover="onMouveOverValues(monthInfo.dayId, data.startMinutesValue)"
                                                  @click="onClick($event, monthInfo.dayId, data.startData.id)"
                                                  :id="'day' + monthInfo.dayId + '_data' + data.startData.id"/>
                                            <polygon points="5,50 15,15 15,85" fill="white" v-if="!data.isFadeIn"
                                                     :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                     stroke-width="1"/>

                                            <!-- une heure de plus (Changement d'heure) -->
                                            <template v-if="monthInfo.dayClocksChange == 1">
                                                <polygon points="1495,50 1485,15 1485,85" fill="white"
                                                         v-if="!data.isFadeOut"
                                                         :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                         stroke-width="1"/>  <!-- flèche droite -->
                                            </template>
                                            <template v-else>
                                                <polygon points="1435,50 1425,15 1425,85" fill="white"
                                                         v-if="!data.isFadeOut"
                                                         :style="'stroke:var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                                         stroke-width="1"/>  <!-- flèche droite -->
                                            </template>
                                        </template>

                                        <line :x1="data.startMinutesValue" y1="0" class="pointor"
                                              :x2="data.startMinutesValue" :y2="data.valuePourcent"
                                              :style="'stroke: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                              :stroke-width="1"
                                              @mouseover="onMouveOverValues(monthInfo.dayId, data.startMinutesValue)"
                                              v-if="data.lenghtMinutesValue == 0"/>
                                    </template>
                                </template>
                            </template>

                            <template v-for="data in OuterData">
                                <line :x1="data.startMinutesValue" y1="0" class="pointor"
                                      :x2="data.startMinutesValue" :y2="100"
                                      :style="'stroke: var(--' + ColorNotCaclulateData[data.periodicity] + ')'"
                                      :stroke-width="1"
                                      @mouseover="onMouveOverValues(monthInfo.dayId, data.startMinutesValue)"
                                      v-if="data.noDay == monthInfo.dayId && data.noMonth == monthInfo.monthId"
                                      @click="onClick($event, monthInfo.dayId, data.id)"/>
                            </template>

                            <rect :width="1440 + (monthInfo.dayClocksChange == 1? 60: 0)" height="100" x="0" y="0"
                                  stroke="black" fill="transparent" stroke-width="1" style="pointer-events: none"/>

                            <!--#region Les lignes  -->
                            <line x1="10" y1="100" x2="10" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="20" y1="100" x2="20" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="30" y1="100" x2="30" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="40" y1="100" x2="40" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="50" y1="100" x2="50" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="60" y1="100" x2="60" y2="75" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="70" y1="100" x2="70" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="80" y1="100" x2="80" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="90" y1="100" x2="90" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="100" y1="100" x2="100" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <line x1="110" y1="100" x2="110" y2="90" stroke="black" stroke-width="1"
                                  style="pointer-events: none"/>
                            <!-- une heure de moins (Changement d'heure) -->
                            <template v-if="monthInfo.dayClocksChange == -1">
                                <rect width="60" height="100" x="120" y="0" fill="black" stroke-width="1"
                                      style="mask: url(#mask-stripe);pointer-events: none"/>
                            </template>
                            <template v-else>
                                <line x1="120" y1="100" x2="120" y2="75" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="130" y1="100" x2="130" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="140" y1="100" x2="140" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="150" y1="100" x2="150" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="160" y1="100" x2="160" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="170" y1="100" x2="170" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                            </template>
                            <!-- une heure de plus (Changement d'heure) -->
                            <template v-if="monthInfo.dayClocksChange == 1">
                                <line x1="180" y1="100" x2="180" y2="75" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="190" y1="100" x2="190" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="200" y1="100" x2="200" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="210" y1="100" x2="210" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="220" y1="100" x2="220" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                                <line x1="230" y1="100" x2="230" y2="90" stroke="black" stroke-width="1"
                                      style="pointer-events: none"/>
                            </template>
                            <line :x1="180 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="180 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="190 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="190 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="200 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="200 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="210 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="210 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="220 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="220 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="230 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="230 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="240 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="240 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="250 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="250 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="260 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="260 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="270 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="270 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="280 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="280 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="290 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="290 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="300 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="300 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="310 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="310 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="320 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="320 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="330 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="330 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="340 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="340 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="350 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="350 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="360 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="360 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="50" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="370 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="370 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="380 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="380 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="390 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="390 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="400 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="400 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="410 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="410 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="420 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="420 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="430 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="430 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="440 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="440 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="450 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="450 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="460 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="460 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="470 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="470 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="480 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="480 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="490 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="490 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="500 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="500 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="510 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="510 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="520 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="520 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="530 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="530 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="540 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="540 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="550 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="550 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="560 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="560 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="570 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="570 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="580 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="580 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="590 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="590 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="600 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="600 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="610 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="610 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="620 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="620 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="630 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="630 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="640 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="640 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="650 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="650 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="660 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="660 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="670 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="670 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="680 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="680 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="690 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="690 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="700 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="700 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="710 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="710 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="720 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="720 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="50" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="730 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="730 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="740 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="740 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="750 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="750 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="760 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="760 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="770 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="770 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="780 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="780 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="790 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="790 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="800 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="800 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="810 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="810 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="820 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="820 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="830 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="830 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="840 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="840 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="850 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="850 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="860 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="860 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="870 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="870 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="880 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="880 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="890 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="890 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="900 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="900 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="910 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="910 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="920 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="920 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="930 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="930 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="940 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="940 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="950 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="950 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="960 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="960 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="970 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="970 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="980 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="980 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="990 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="990 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1000 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1000 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1010 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1010 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1020 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1020 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1030 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1030 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1040 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1040 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1050 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1050 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1060 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1060 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1070 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1070 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1080 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1080 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="50" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1090 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1090 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1100 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1100 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1110 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1110 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1120 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1120 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1130 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1130 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1140 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1140 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1150 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1150 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1160 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1160 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1170 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1170 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1180 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1180 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1190 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1190 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1200 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1200 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1210 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1210 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1220 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1220 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1230 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1230 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1240 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1240 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1250 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1250 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1260 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1260 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1270 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1270 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1280 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1280 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1290 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1290 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1300 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1300 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1310 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1310 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1320 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1320 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1330 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1330 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1340 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1340 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1350 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1350 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1360 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1360 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1370 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1370 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1380 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1380 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="75" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1390 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1390 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1400 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1400 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1410 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1410 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1420 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1420 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>
                            <line :x1="1430 + (monthInfo.dayClocksChange == 1? 60: 0)" y1="100"
                                  style="pointer-events: none"
                                  :x2="1430 + (monthInfo.dayClocksChange == 1? 60: 0)" y2="90" stroke="black"
                                  stroke-width="1"/>

                            <!--#endregion -->
                        </svg>

                        <template v-for="(data, index) in Data[monthInfo.dayId - 1]?.values">
                            <template v-if="data != undefined">
                                <!-- Première partie - la valeur -->
                                <svg :width="(100 / 1440 * data.lenghtMinutesValue) + '%'" height="1rem"
                                     :style="'left: ' + (100 / 1440 * data.startMinutesValue) + '%'"
                                     class="position-absolute" style="pointer-events: none;"
                                     v-if="data.lenghtMinutesValue > 60">
                                    <text x="50%" y="50%" text-anchor="middle" font-size="0.75rem"
                                          dominant-baseline="middle" fill="white" class="shadow"
                                          style="pointer-events: auto;"
                                          @click="onClick($event, monthInfo.hourId, data.startData.id)">
                                        {{ Intl.NumberFormat('fr-FR').format(data.value) }}
                                    </text>
                                </svg>

                                <!-- Deuxième partie - la popup -->
                                <b-popover triggers="hover" placement="top"
                                           v-if="SelectedFactor?.Temporality == 1"
                                           :target="'day' + monthInfo.dayId + '_data' + data.startData.id">
                                    <div class="m-0 p-1 d-flex flex-row flex-wrap" text-variant="dark">
                                        <div class="d-flex m-1 p-0">
                                            <div class="flex-column border p-1 m-0 text-center"
                                                 :class="'border-' + ColorNotCaclulateData[data.periodicity]">
                                                {{ getMomentDateToString(data.startData.date, true) }}
                                            </div>
                                            <div class="left-arrow"
                                                 :class="'bg-' + ColorNotCaclulateData[data.periodicity]"></div>
                                            <div
                                                class="pl-2 pr-2 m-0 flex-grow-1 mh-100 h-100 font-weight-bold text-white"
                                                :class="'bg-' + ColorNotCaclulateData[data.periodicity] +
                                              ' border-' + ColorNotCaclulateData[data.periodicity]">
                                                    <span class="d-flex align-items-center h-100 mh-100">
                                                        {{ Intl.NumberFormat('fr-FR').format(data.value) }}
                                                    </span>
                                            </div>
                                            <div class="right-arrow"
                                                 :class="'bg-' + ColorNotCaclulateData[data.periodicity] +
                                              ' border-' + ColorNotCaclulateData[data.periodicity]"></div>
                                            <div class="p-1 m-0 border text-center"
                                                 :class="'border-' + ColorNotCaclulateData[data.periodicity]">
                                                {{ getMomentDateToString(data.endData.date, false) }}
                                            </div>
                                        </div>
                                    </div>
                                </b-popover>
                            </template>
                        </template>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">

import {Component, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import moment from "moment";
import {mixins} from "vue-class-component";
import {FactorUtils} from "./FactorUtils";
import FactorCalendarTypeEnum from "@/enums/FactorCalendarTypeEnum";
import locales from '../locales/FactorCalendarMonth.json';
import { Getter } from "vuex-class";

@Component({
    computed: {
        FactorCalendarTypeEnum() {
            return FactorCalendarTypeEnum
        }
    },
    methods: {},
    components: {},
    i18n:{messages: locales}
})
export default class FactorCalendarMonth extends mixins(Vue, FactorUtils) {
    @Prop()
    public Variant: string;

    @Getter('SessionStore/GetLanguage')
    private language!: string;

    /** Données du facteur sur cette période */
    @Prop({default: () => []})
    public Data!: any[];

    /** Premières Données du facteur en dehors de la période */
    @Prop()
    public OuterData!: any[];

    /** Pour l'affichage des données en tooltip */
    @PropSync("HoverDatas", {default: () => []})
    public hoverDatas!: any[];

    /** Paramètres transmis pour l'ajout, la modification/suppression des données*/
    @PropSync("ShowDatas", {default: () => []})
    public showDatas!: any[];
    @PropSync("ShowModal", {default: () => false})
    public showModal!: boolean;

    /** Date sélectionnée*/
    @Prop({default: () => Date.now()})
    public SelectedDate: Date;

    /** Couleur des données suivant le type de facteur */
    @Prop({default: () => 'tertiary'})
    public ColorCaclulateData: string;
    @Prop({default: () => ['primary']})
    public ColorNotCaclulateData: string[];

    /** Facteur sélectionné */
    @Prop({default: () => {}})
    public SelectedFactor!: any;

    /** Période affichée */
    @PropSync("StartPeriod")
    public startPeriod: moment.Moment;
    @PropSync("EndPeriod")
    public endPeriod: moment.Moment;

    /** Pour accéder à l'enum dans la partie template */
    private factorCalendarTypeEnum = FactorCalendarTypeEnum;

    /** Propriété pour la modale */
    private selectedDate: Date = new Date(Date.now());

    /** Information du calendrier à afficher */
    private monthInfos: { monthId: number, dayId: number, dayName: string, weekend: boolean, dayClocksChange: number }[] = [];
    /** Informations des données par minutes et jours */
    private tooltipData: any[] = [];

    /**
     * Pour l'affectation de la variable privée selectedDate
     * @protected
     */
    @Watch('SelectedDate', {immediate: true})
    protected modifedDate() {
        console.debug('FactorCalendarMonth.vue - modifedDate');
        this.selectedDate = this.SelectedDate;
    }

    /**
     * Recalcule du calendrier à afficher
     * @protected
     */
    @Watch("SelectedDate")
    protected updateSelectedDate() {
        console.debug('FactorCalendarMonth.vue - SelectedDate');
        this.loadCalendar();
    }

    /**
     * Rechargement des listes liées aux données
     * @protected
     */
    @Watch("Data", {deep: true, immediate: true})
    protected setData() {
        console.debug('FactorCalendarMonth.vue - setData');
        this.tooltipData = [];
        this.loadDatas().then(() => {
        });
    }

    /**
     * Pour l'affichage des valeurs survolées sur la minute
     * @param day
     * @param minute
     * @private
     */
    private onMouveOverValues(day: number, minute: number) {
        this.hoverDatas = [...this.tooltipData[day - 1][minute]];
        console.debug('FactorCalendarMonth.vue - onMouveOverValues - day, minute', day - 1, minute, this.hoverDatas);
    }

    /** Pour éviter les clicks intempestifs */
    private onClickDate: moment.Moment = moment();
    /**
     * Récupération des données au click pour l'ajout ou la modification/suppression des données à cette minute
     * @param evt
     * @param day
     * @param dataId
     * @private
     */
    private onClick(evt, day, dataId = undefined) {
        if (this.SelectedFactor != undefined && this.SelectedFactor != null) {
            console.debug('FactorCalendarMonth.vue - onClick - evt : %O - day : %O - dataId : %O', evt, day, dataId);
            let datas: any[] = [];
            let minuteClick = 0;

            if (moment().diff(this.onClickDate) > 100) {
                this.onClickDate = moment();
                if (dataId == undefined) {
                    if (evt != undefined) {
                        let dim = evt.target.getBoundingClientRect();
                        let x = evt.clientX - dim.left;
                        let y = evt.clientY - dim.top;

                        minuteClick = Math.round(x * 1440 / dim.width);

                        if (minuteClick != Infinity && minuteClick != -Infinity) {
                            for (let i = minuteClick - 4; i <= minuteClick + 4; i++) {
                                for (let j = 0; j < this.tooltipData[day][i]?.length; j++) {
                                    let a = {...this.tooltipData[day - 1][i][j]};
                                    console.debug('FactorCalendarMonth.vue - onClick - day, minuteClick, a', day, minuteClick, a);
                                    if (a == undefined || (Object.keys(a).length == 0 && a.constructor == Object)) {
                                    } else {
                                        console.debug('FactorCalendarMonth.vue - onClick - startDate', a.startData.date);
                                        let startDate = this.getMomentDate(a.startData.date, true);
                                        console.debug('FactorCalendarMonth.vue - onClick - endDate', a.endData.date);
                                        let endDate = this.getMomentDate(a.endData.date, true);
                                        datas.push({
                                            NoMonth: a.startData.noMonth,
                                            NoDay: a.startData.noDay,
                                            Status: 1,
                                            DataId: a.startData.id,
                                            StartDate: startDate.format('YYYY-MM-DD'),
                                            StartTime: startDate.format('HH:mm'),
                                            EndDate: endDate.format('YYYY-MM-DD'),
                                            EndTime: endDate.format('HH:mm'),
                                            Periodicity: a.periodicity,
                                            Value: a.value,
                                            Unit: a.unit,
                                            Collapsed: false
                                        });
                                    }
                                }
                            }
                        }
                        console.debug('FactorCalendarMonth.vue - onClick - minuteClick', minuteClick);
                    }
                } else {
                    /** Affichage de la donnée sélectionnée */
                    let a = this.Data[day - 1]?.values?.find((a) => a.startData.id == dataId);
                    if (this.OuterData != undefined && this.OuterData.length > 0 && a == undefined || a.length == 0) {
                        let value = this.OuterData.find(a => a.id == dataId);
                        if (value != undefined)
                            a = {
                                endData: {...this.OuterData[0]},
                                isFadeIn: false,
                                isFadeOut: false,
                                lenghtMinutesValue: 0,
                                periodicity: this.OuterData[0].periodicity,
                                startData: {...this.OuterData[0]},
                                startMinutesValue: this.OuterData[0].startMinutesValue,
                                unit: this.OuterData[0].unit,
                                value: this.OuterData[0].value,
                                valuePourcent: 100
                            };
                    }
                    console.debug('FactorCalendarMonth.vue - onClick - dataId : %O, a: %O, this.Data : %O', dataId, a, day, this.Data);
                    if (a != undefined) {
                        console.debug('FactorCalendarMonth.vue - onClick - startDate: ', a.startData.date);
                        let startDate = this.getMomentDate(a.startData.date, true);
                        console.debug('FactorCalendarMonth.vue - onClick - endDate :', a.endData.date);
                        let endDate = this.getMomentDate(a.endData.date, true);
                        console.debug('FactorCalendarMonth.vue - onClick - startDate : %O, endDate : %O', startDate, endDate);
                        if (this.SelectedFactor?.Temporality == 3 && a.startData.date != a.endData.date) {
                            datas.push({
                                NoMonth: a.startData.noMonth,
                                NoDay: a.startData.noDay,
                                Status: 1,
                                DataId: a.startData.id,
                                StartDate: startDate?.format('YYYY-MM-DD'),
                                StartTime: startDate?.format('HH:mm'),
                                EndDate: startDate?.format('YYYY-MM-DD'),
                                EndTime: startDate?.format('HH:mm'),
                                Periodicity: a.periodicity,
                                Value: a.startData.value, Unit: a.unit, Collapsed: false
                            });
                            datas.push({
                                NoMonth: a.endData.noMonth,
                                NoDay: a.endData.noDay,
                                Status: 1,
                                DataId: a.endData.id,
                                StartDate: endDate?.format('YYYY-MM-DD'),
                                StartTime: endDate?.format('HH:mm'),
                                EndDate: endDate?.format('YYYY-MM-DD'),
                                EndTime: endDate?.format('HH:mm'),
                                Periodicity: a.periodicity,
                                Value: a.endData.value,
                                Unit: a.unit,
                                Collapsed: false
                            });
                        } else {
                            datas.push({
                                NoMonth: a.startData.noMonth,
                                NoDay: a.startData.noDay,
                                Status: 1,
                                DataId: a.startData.id,
                                StartDate: startDate?.format('YYYY-MM-DD'),
                                StartTime: startDate?.format('HH:mm'),
                                EndDate: endDate?.format('YYYY-MM-DD'),
                                EndTime: endDate?.format('HH:mm'),
                                Periodicity: a.periodicity,
                                Value: a.value, Unit: a.unit, Collapsed: false
                            });
                        }
                        console.debug('FactorCalendarMonth.vue - onClick - datas :', datas);
                    }
                }

                if (datas.length > 0) {
                    datas[0].Collapsed = true;
                } else {
                    /** Ajout d'une nouvelle donnée */
                    console.debug('FactorCalendarMonth.vue - onClick - selectedDate :', this.selectedDate);
                    let date = this.getMomentDate(this.selectedDate, true);
                    console.debug('FactorCalendarMonth.vue - onClick - date', date, minuteClick);
                    date = moment({year: date.year(), month: date.month(), day: day});
                    if (minuteClick != undefined) {
                        date.add(minuteClick, 'minutes');
                    }
                    console.debug('FactorCalendarMonth.vue - onClick - date :', date);
                    let dataId = Math.abs(Math.min(...this.Data.map(a=> a.ids).flat())) ;
                    if (dataId ==  Infinity || isNaN(dataId)) {
                        dataId = 0;
                    }
                    datas.push({
                        NoMonth:  this.getDateToNumber(date, 'month'),
                        NoDay: this.getDateToNumber(date, 'day'),
                        Status: 0, DataId: dataId * (-1) - 1,
                        StartDate: date.format('YYYY-MM-DD'), StartTime: date?.format('HH:mm'),
                        EndDate: date.format('YYYY-MM-DD'), EndTime: date?.format('HH:mm'),
                        Periodicity: 0, Value: undefined, Unit: this.SelectedFactor?.Unit, Collapsed: true
                    });
                }

                Vue.set(this, 'onClickDate', moment());
                Vue.set(this, 'showDatas', datas);
                Vue.set(this, 'showModal', datas.length > 0 && this.SelectedFactor.Temporality == 1 /* Limited */);
                console.debug('FactorCalendarMonth.vue - onClick - this.showDatas : %O - day : %O', this.showDatas, day);
            }
            this.onClickDate = moment();

            if (this.SelectedFactor.Temporality != 1 /* Limited */){
                this.$bvToast.toast(this.$t('DisabledFactorEdit').toString(), { // $t('DisabledFactorEdit') / "Il n'est pas encore possible de modifier des facteurs de type indexés ou instantanés."
                    title: this.$t('ImpossibleAction').toString(), // $t('ImpossibleAction') / "Action impossible",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }
        }
    }

    /**
     * Chargement de données pour les trier par minutes
     * @protected
     */
    protected loadDatas(): Promise<any> {
        console.debug('FactorCalendarMonth.vue - loadDatas');
        this.hoverDatas = [];
        return new Promise(async (resolve, reject) => {
            this.tooltipData = [];
            if (this.Data != undefined && this.Data.length > 0) {
                for (let i = 0; i < this.Data.length; i++) {
                    let datas = {...this.Data[i]};
                    this.tooltipData.push([]);
                    for (let j = 0; j < 1440; j++) {
                        let dataMinute = [];
                        // Seule des données de type instantané auront un tooltip.
                        dataMinute = datas.values.filter(a => a.startMinutesValue == j);
                        dataMinute.forEach(a => {
                            a.noStep = i;
                            return a
                        });
                        this.tooltipData[i].push(dataMinute);
                    }
                    if (this.OuterData!= undefined && this.OuterData.length > 0 && i == this.OuterData[0].noDay - 1){
                        this.tooltipData[i][this.OuterData[0].startMinutesValue].push({
                            endData: {...this.OuterData[0]},
                            isFadeIn:false,
                            isFadeOut:false,
                            noStep: i,
                            lenghtMinutesValue:0,
                            periodicity:this.OuterData[0].periodicity,
                            startData: {...this.OuterData[0]},
                            startMinutesValue:this.OuterData[0].startMinutesValue,
                            unit:this.OuterData[0].unit,
                            value:this.OuterData[0].value,
                            valuePourcent:100
                        });
                    }
                }
            }
            resolve(true);
        });
    }

    /**
     * Chargement du calendrier
     * @private
     */
    private loadCalendar() {
        console.debug('FactorCalendarMonth.vue - loadCalendar');
        let startDate: moment.Moment = moment(moment(this.selectedDate).clone().toDate()); /* pour supprimer les heures */
        let endDate: moment.Moment = startDate.clone();

        moment.locale(this.language);

        this.monthInfos = [];
        startDate = moment(startDate.year() + '-' + (startDate.month() + 1 /* les mois commencent à 0. */) + '-01');
        endDate = startDate.clone().add({months: 1});
        let nbDays = endDate.diff(startDate, 'days');
        for (let i = 0; i < nbDays; i++) {
            /* Calcul des dates de changement d'heure */
            let date = startDate.clone().add({days: i});
            let gmt2 = date.clone().add({hours: 4}).toDate().toTimeString();
            let gmt0 = date.clone().subtract({days: 1}).add({hours: 4}).toDate().toTimeString();

            this.monthInfos.push({
                monthId: date.month() + 1,
                dayId: date.date(),
                dayName: date.format('ddd').toUpperCase().replace('.', '').charAt(0),
                weekend: date.weekday() == 5 || date.weekday() == 6, /* Moment in FR */
                dayClocksChange: gmt2.substring(gmt2.indexOf('('), gmt2.length) != gmt0.substring(gmt0.indexOf('('), gmt0.length)
                    ? gmt2.substring(gmt2.indexOf('('), gmt2.length) == "(heure d’été d’Europe centrale)" ? -1 : +1 : 0
            });
        }
        console.debug('FactorCalendarMonth.vue - loadCalendar - startDate, endDate, monthInfos', startDate.toDate(),
            endDate.toDate(), this.monthInfos);

        this.startPeriod = startDate;
        this.endPeriod = endDate;
    }

    /** Au chargement */
    mounted() {
        console.debug('FactorCalendarMonth.vue - mounted');
        this.loadCalendar();

        this.tooltipData = [];
        this.loadDatas().then(() => {
        });
    }
}

</script>
<style scoped>

/** Style pour afficher dans le tooltip la flèche de droite */
:deep(.right-arrow) {
    position: relative;
    left: -1px;
    width: 15px !important;
    clip-path: polygon(0 0, 0 100%, 100% 50%);
}

/** Style pour afficher dans le tooltip la flèche de gauche */
:deep(.left-arrow) {
    position: relative;
    right: -1px;
    width: 15px !important;
    clip-path: polygon(100% 100%, 100% 0, 0 50%);
}

/*.hatching {
    background: repeating-linear-gradient(-45deg, transparent, transparent 2px, black 2px, black 4px);
}*/

/** Style pour afficher des heures dans le calendrier "Week" */
/*.number {
    top: -3px !important;
    position: relative;
}*/

/* Style pour dans le cas où aucune valeur n'est présente */
/*.noValue {
    border: 0px !important;
    color: transparent;
    padding: 1px;
}*/

:deep(.shadow) {
    /* Plusieurs pour accentuer le contour. */
    text-shadow: 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black,
    0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black;
}

</style>